module.exports = __webpack_public_path__ + "img/old_book.6b1ae964.svg";